<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">Catégorie d'activité</h4>

        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><router-link :to="{ name: 'home' }">Tableau de bord</router-link></li>
            <li class="breadcrumb-item"><router-link :to="{ name: 'home' }">Configurations</router-link></li>
            <li class="breadcrumb-item active">Catégorie d'activité</li>
          </ol>
        </div>

      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <form @submit.prevent="createCategorie">
          <div class="card card-animate">

            <div class="card-body">
              <div class="row text-start">
                <div class="col-sm-12">
                  <label for="firstName" class="form-label">Nom</label>
                  <input v-model="categorieActivite.nom" type="text" class="form-control" required>
                  <div class="invalid-feedback">Veuillez entrer le nom de la taxe</div>
                </div>
              </div>
              <div class="row text-start mt-3">
                <div class="col-sm-12">
                  <label for="firstName" class="form-label">Collectivité</label>
                  <select v-model="categorieActivite.entite" type="text" class="form-control" required>
                    <option :key="item.id" :value="item.id" v-for="item in listCollectivite">{{item.nom}}</option>
                  </select>
                  <div class="invalid-feedback">Veuillez entrer le nom de la taxe</div>
                </div>
              </div>
              <div class="row text-start mt-3">
                <div class="col-sm-12">
                  <label for="firstName" class="form-label">Description</label>
                  <textarea v-model="categorieActivite.description" type="text" class="form-control" ></textarea>
                  <div class="invalid-feedback">Veuillez entrer le nom de la taxe</div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12">
                  <div class="form-check form-switch form-switch-success">
                    <input  v-model="categorieActivite.enabled" class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" >
                    Active ?
                  </div>
                </div>
              </div>

            </div>
            <div class="card-footer">
              <div class="row">
                <button type="submit" class="btn btn-primary">Enregistrer</button>

              </div>
            </div>
          </div>

        </form>

      </div>
    </div>
  </div>
</template>

<script>
import CategorieActivite from "@/entity/CategorieActivite";
import Repository from '@/repository/CategorieActiviteRepository'
import EntiteRepository from '@/repository/EntiteRepository'
export default {
  name: 'createCategorieActivitePage',
  data() {
    return {
      categorieActivite: new CategorieActivite(),
      repository: new Repository(),
      entiteRepo: new EntiteRepository(),
      listCollectivite: null


    }
  },
  computed: {
  },
  methods: {
    createCategorie(){
      this.repository.create(this.categorieActivite);
      this.$router.push({ name: 'listeCategorieActivite' })
    }

  },
  created() {
    this.entiteRepo.search([{ colonne: '', operator: '', value: '' }], 'ent.nom', 'asc', 30, 1)
        .then(response => {
          this.listCollectivite = response.data;
          //   console.log(this.listCollectivite);
        })
        .catch(error => {
          console.log(error);
        });
  }
}
</script>